import React from 'react';
import Header from './header';
import Footer from './footer';

const bikes = [
  {
      id: 1,
      title: "Yamaha FZ",
      price: "Starts at ₹21/hr",
      img: "1"
  },
  {
      id: 2,
      title: "Honda CB Hornet 160",
      price: "Starts at ₹28/hr",
      img: "2"
  },
  {
      id: 3,
      title: "TVS Apache RTR 180",
      price: "Starts at ₹33/hr",
      img: "3"
  },
  {
      id: 4,
      title: "Yamaha Fazer 25",
      price: "Starts at ₹30/hr",
      img: "4"
  }
]

const scooters = [
  {
      id: 1,
      title: "Honda Activa 5G",
      price: "Starts at ₹15/hr",
      img: "1"
  },
  {
      id: 2,
      title: "Honda Dio",
      price: "Starts at ₹18/hr",
      img: "2"
  },
  {
      id: 3,
      title: "Honda Aviator",
      price: "Starts at ₹15/hr",
      img: "3"
  }
]

const bikes250 = [
  {
      id: 1,
      title: "Royal Enfield Himalayan",
      price: "Starts at ₹45/hr",
      img: "Royal Enfield Himalayan"
  },
  {
      id: 2,
      title: "Jawa Standard",
      price: "Starts at ₹57/hr",
      img: "Jawa Standard"
  },
  {
      id: 3,
      title: "KTM RC 390",
      price: "Starts at ₹60/hr",
      img: "KTM RC 390"
  },
  {
      id: 4,
      title: "BMW G310R",
      price: "Starts at ₹92/hr",
      img: "BMW G310R"
  }
]

const Fleets = () => {
      return <div >
     <Header />
     <div className='fleet-container' id={'fleet1'} >
            <div className='container'>
                <div className='fleet-header'>
                    <h1>Our Fleets</h1>
                </div>
                <div>

       <div className='card-container' >
         <div>
         <h2>BIKES = 250CC</h2> 
               { bikes.map( bike => (
                <div className='card-box' id={bike.id} >
                <div className='card-image'>
                    <img src={require(`../assets/bike/${bike.img}.png`)} alt='card-img'></img>
                </div>
                <div className='card-detail'>
                    <h1>{bike.title}</h1>
                    <p>{bike.price}</p>
                </div>
            </div>
            ))}</div>
         <div> 
         <h2>SCOOTERS</h2>
              { scooters.map( scooter => (
              <div className='card-box' id={scooter.id} >
              <div className='card-image'>
                      <img src={require(`../assets/scooters/${scooter.img}.png`)} alt='card-img'></img>
                      
                  </div>
              <div className='card-detail'>
              <h1>{scooter.title}</h1>
              <p>{scooter.price}</p>
          </div>
            </div>
            ))}</div> 
            <div>
            <h2>BIKES 250CC</h2>
            { bikes250.map( bike250 => (
                
        <div className='card-box' id={bike250.id} >
        <div className='card-image'>
            <img src={require(`../assets/bike250/${bike250.img}.png`)} alt='card-img'></img>
        </div>
        <div className='card-detail'>
            <h1>{bike250.title}</h1>
            <p>{bike250.price}</p>
        </div>
    </div>
    
            ))}</div>
  </div>;
                </div>
            </div>
        </div>
     <Footer />
    </div>
    }
export default Fleets
